import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function BackButton() {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate(-1)}
      className="bg-white/95 backdrop-blur-sm shadow-lg hover:shadow-xl transition-all p-3 rounded-lg flex items-center gap-2 hover:gap-3"
    >
      <ArrowLeft className="h-5 w-5 text-gray-700" />
      <span className="text-sm font-medium text-gray-700">返回</span>
    </button>
  )
}
